import { api } from "./api";

export const CATEGORIES = { form: "फॉर्म", govt: "सरकारी सेवा", insurance: "इंश्योरेंस", service: "नई / अन्य सेवा", other: "अन्य" };
export const PRIORITIES = { urgent: "जरूरी", normal: "सामान्य", later: "बाद में" };
export const TOPIC_STATUS = { not_started: "शुरू करना बाकी", in_progress: "जारी", on_hold: "रुकी हुई", done: "पूरी हुई" };
export const ITEM_STATUS = { pending: "बाकी", researching: "रिसर्च चल रही है", confirm: "पुष्टि बाकी", done: "पूरा" };
export const ITEM_TONE = { pending: "bg-slate-100 text-slate-700", researching: "bg-blue-100 text-blue-800", confirm: "bg-amber-100 text-amber-800", done: "bg-green-100 text-green-800" };
export const TOPIC_TONE = { not_started: "bg-slate-100 text-slate-700", in_progress: "bg-blue-100 text-blue-800", on_hold: "bg-amber-100 text-amber-800", done: "bg-green-100 text-green-800" };
export const SOURCE_TYPES = { website: "वेबसाइट", whatsapp: "WhatsApp ग्रुप", other: "अन्य" };
export const ACTION_HI = { create: "बनाई", update: "बदलाव", status: "स्थिति", trash: "Trash", restore: "वापस", purge: "हमेशा के लिए हटाई", check: "चेक", undo: "Undo", pause: "Pause", resume: "चालू" };

const blobCache = {};
export const fileBlobUrl = async (fid) => {
  if (!blobCache[fid]) {
    blobCache[fid] = api.get(`/research/files/${fid}`, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data))
      .catch((e) => { delete blobCache[fid]; throw e; });
  }
  return blobCache[fid];
};
export const isImage = (f) => (f.content_type || "").startsWith("image/");

export const fmtIST = (iso, withTime = true) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("hi-IN", { timeZone: "Asia/Kolkata", day: "numeric", month: "short", year: "numeric", ...(withTime && { hour: "numeric", minute: "2-digit" }) });
};
export const fmtSlot = (s) => { const [h, m] = s.split(":").map(Number); return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`; };
